import { ClientCollection } from "../clientCollection.js";
class AbstractCategoryCollection extends ClientCollection {
}
export { AbstractCategoryCollection };
